// CurrentPromotions.jsx
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { fetchCurrentPromotions } from "../../http/bookAPI";
import { Context } from "../../index";
import { useNavigate } from "react-router-dom";
import {LIBRARY_ROUTE, PAY_ROUTE, PROMO_PAY_ROUTE} from "../../utils/consts";

function fmtTimeLeft(ms, bonusExp) {
    if (!Number.isFinite(ms) || ms <= 0) return null;

    const totalSec = Math.floor(ms / 1000);
    const d = Math.floor(totalSec / 86400);
    const h = Math.floor((totalSec % 86400) / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    const sloganD = bonusExp ? "Will Expire:" : "Limited time:";
    const sloganH = bonusExp ? "Expire in:" : "Final hours:";
    const sloganM = bonusExp ? "Hurry up:" : "Last chance:";
    const sloganS = bonusExp ? "Final notice:" : "Hurry up:";
    const pad = (n) => String(n).padStart(2, "0");

    if (d > 0) return `${sloganD} <strong>${d}D ${pad(h)}:${pad(m)}</strong>`;
    if (h > 0) return `${sloganH} <strong>${pad(h)}:${pad(m)}:${pad(s)}</strong>`;
    if (m > 0) return `${sloganM} <strong>${pad(m)}:${pad(s)}</strong>`;
    return `${sloganS} <strong>0:${pad(s)}</strong>`;
}

const CurrentPromotions = () => {
    const [data, setData] = useState(null); // { server_time, items: [] }
    const [error, setError] = useState("");
    const [tick, setTick] = useState(Date.now()); // локальный таймер
    const serverOffsetRef = useRef(0);
    const { user } = useContext(Context);
    const userId = user?.user?.id || null;
    const navigate = useNavigate();

    const load = async () => {
        try {
            setError("");
            const resp = await fetchCurrentPromotions(userId ? { userId } : undefined);
            setData(resp);
            if (resp?.server_time) {
                const serverNow = new Date(resp.server_time).getTime();
                serverOffsetRef.current = serverNow - Date.now();
            }
        } catch {
            setError("Failed to load promotions.");
            setData(null);
        }
    };

    useEffect(() => {
        load();
        // раз в 5 минут
        const poll = setInterval(load, 5 * 60 * 1000);
        // обновлять отсчёт каждую секунду
        const t = setInterval(() => setTick(Date.now()), 1000);
        return () => {
            clearInterval(poll);
            clearInterval(t);
        };
    }, [userId]);

    const items = data?.items || [];
    const nowMs = useMemo(() => Date.now() + serverOffsetRef.current, [tick]);

    if (error || !items.length) return null;

    const getCtaText = (it) => {
        if (Number.isFinite(Number(it.discount_pct))) return `${Number(it.discount_pct)}% OFF`;
        if (Number.isFinite(Number(it.bonus_amount))) return `${Number(it.bonus_amount)} Virt`;
        return "View offer";
    };

    const handleClick = (promo, e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();

        if (promo?.stripe?.coupon_id) {
            const params = new URLSearchParams();
            params.set("coupon", promo.stripe.coupon_id);

            const pct = Number(promo?.discount_pct);
            if (Number.isFinite(pct) && pct > 0) params.set("discount", String(pct));

            navigate(`${PROMO_PAY_ROUTE}?${params.toString()}`);
        } else {
            navigate(LIBRARY_ROUTE);
        }
    };


    return (
        <Card className="border border-success mb-2 mt-2">
            <Card.Body className="py-2">
                {items.map((it) => {
                    const until = it.countdown_to ? new Date(it.countdown_to).getTime() : null;
                    const leftStr = until ? fmtTimeLeft(until - nowMs, it.bonus_amount ? it.bonus_amount : '') : null;
                    const key = it.key || `${it.campaign || "promo"}-${it.label || "untitled"}-${it.countdown_to || "open"}`;

                    return (
                        <div
                            key={key}
                            className="d-flex align-items-center gap-2 flex-nowrap mb-0"
                        >
                            {/* левая колонка — текст, может быть многострочным */}
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                <div className="promo-text small">
                                    <span className="promo-text-title">{it.label}</span>
                                    {it.subtitle ? <span className="promo-text-sub"> {it.subtitle}</span> : null}

                                </div>
                            </div>

                            {/* правая колонка — кнопка; всегда справа, не переносится, по центру по вертикали */}
                            <div className="promo-wrap d-flex align-items-center ms-auto flex-shrink-0">
                                <button
                                    type="button"
                                    className="btn-promo badge-pill badge-countdown d-inline-flex align-items-center"
                                    title={it.countdown_to || it.label}
                                    onClick={(e) => handleClick(it, e)}
                                    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick(it, e)}
                                    aria-label={getCtaText(it)}
                                >
                                    <span className="h6 mb-0 me-2 fw-bold">{getCtaText(it)}</span>
                                    {leftStr && (
                                        <span
                                            className="countdown-text small"
                                            dangerouslySetInnerHTML={{ __html: leftStr }}
                                        />
                                    )}
                                </button>
                            </div>
                        </div>
                    );
                })}



            </Card.Body>
        </Card>
    );
};

export default CurrentPromotions;
